import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { getColorCode } from '../utils/helper'
import { legacyDevice } from './types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const commonCondition = process.env.REACT_APP_REALM !== 'Hitron'
// ||
// process.env.REACT_APP_REALM === 'Customer' ||
// process.env.REACT_APP_REALM === 'earthlink' ||
// process.env.REACT_APP_REALM === 'entpnt' ||
// process.env.REACT_APP_REALM === 'Scalingtests'

export const isHitron = process.env.REACT_APP_REALM === 'Hitron'
export const isScaling = process.env.REACT_APP_REALM === 'Scalingtests'
export const isEntryPoint = process.env.REACT_APP_REALM === 'entpnt'
export const isEntryPointProd = process.env.REACT_APP_REALM === 'entpnt' && process.env.REACT_APP_ENV === 'prod'
export const isEntryPointDev = process.env.REACT_APP_REALM === 'entpnt' && process.env.REACT_APP_ENV === 'dev'

export const ELEPcommon = process.env.REACT_APP_REALM === 'earthlink' || process.env.REACT_APP_REALM === 'entpnt'

export const customerScalling =
  process.env.REACT_APP_REALM === 'Customer' || process.env.REACT_APP_REALM === 'Scalingtests'

export const customerELEP = ELEPcommon || customerScalling

export const coustomerDev = process.env.REACT_APP_REALM === 'Customer' && process.env.REACT_APP_ENV === 'dev'

export const devCustomerScalling = coustomerDev || process.env.REACT_APP_REALM === 'Scalingtests'

export const StagingScallingCustomer = process.env.REACT_APP_REALM === 'Hitron-staging' || customerScalling

export const hitronStaging = process.env.REACT_APP_REALM === 'Hitron-staging'
export const earthlink = process.env.REACT_APP_REALM === 'earthlink'

export const getStatusColor = (status: string) => {
  switch (status) {
    case 'CREATED':
    case 'SEGMENT_CREATED':
      return '#3498db'
    case 'IN_PROGRESS':
    case 'STARTED':
    case 'SEGMENT_STARTED':
      return '#f39c12'
    case 'COMPLETED':
    case 'SEGMENT_COMPLETED':
    case 'SUCCESS':
    case 'online':
    case 'active':
      return '#2ecc71'
    case 'FAILED':
    case 'FAILURE':
    case 'TIMEOUT':
    case 'offline':
    case 'STOPPED':
    case 'SEGMENT_STOPPED':
    case 'unreachable':
    case 'suspended':
      return '#e74c3c'
    case 'PENDING':
    case 'WAIT_FOR_AUTO_START':
      return '#95a5a6'
    case 'SCHEDULED':
      return '#8e44ad'
    default:
      return 'black'
  }
}

export const hitronCustomerEntpntColor =
  process.env.REACT_APP_COLOR === 'hitron' ||
  process.env.REACT_APP_COLOR === 'customer' ||
  process.env.REACT_APP_COLOR === 'entpnt'

export const errorTextColorStyle: React.CSSProperties = {
  color: getColorCode('redToBlue'),
  display: 'block',
  textAlign: 'left'
}

export const errorFun = (error: boolean | undefined | '') => {
  return {
    border: error ? `1px solid ${getColorCode('redToBlue')}` : `1px solid #d9d9d9`
  }
}

export const getPopupClassName = () => {
  const env = process.env.REACT_APP_COLOR
  switch (env) {
    case 'hitron':
      return 'ok-button-hitron'
    case 'customer':
      return 'ok-button-customer'
    case 'entpnt':
      return 'ok-button-entpnt'
    default:
      return 'ok-button-default'
  }
}

export const getColor = () => {
  switch (process.env.REACT_APP_COLOR) {
    case 'hitron':
      return '#004C97'
    case 'customer':
      return '#ff974c'
    case 'entpnt':
      return '#45546A'
    default:
      return '#FF8181'
  }
}

export const getDeviceIdentifier = (legacyData?: legacyDevice) => {
  if (!legacyData) return ''
  return (legacyData?.imei?.trim() ? legacyData?.imei : legacyData?.serial_num) ?? ''
}

export const legacyQueryParamPayload = [
  'imei',
  'make',
  'model',
  'serial_number',
  'mac',
  'ip',
  'ssid_2g',
  'ssid_2g_passphrase',
  'ssid_5g',
  'ssid_5g_passphrase'
]

export const getLightColor = () => {
  switch (process.env.REACT_APP_COLOR) {
    case 'hitron':
      return '#004c973d'
    case 'customer':
      return '#fdae7569'
    case 'entpnt':
      return '#54848057'
    case 'scaling':
      return '#6581fa'
    default:
      return '#FF8181'
  }
}
